import { render } from "./InvoiceModal.vue?vue&type=template&id=791a610f&scoped=true"
import script from "./InvoiceModal.vue?vue&type=script&lang=js"
export * from "./InvoiceModal.vue?vue&type=script&lang=js"

import "./InvoiceModal.vue?vue&type=style&index=0&id=791a610f&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-791a610f"]])

export default __exports__